"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
function ModelTuningStep1(props) {
    const { setModelDetails, visualizationData, isVisualizationTable, errorMessages } = props;
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const [visualizationImgs, setVisualizationImgs] = react_1.useState([]);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        setVisualizationImgs(visualizationData);
        console.log("visualizationImgs", visualizationImgs);
    }, [visualizationData]);
    const actualNames = {
        penalty: "Penalty",
        C: "Regularization Parameter (C)",
        max_iter: "Maximum Iterations",
        solver: "Optimization Algorithm (solver)",
        subSample: "Subsample",
        learning_rate: "Learning Rate",
        max_depth: "Maximum Depth",
        gamma: "Minimum Loss Reduction (gamma)",
        alpha: "Regularization Term (alpha)",
        eta: "Learning Rate (eta)",
        var_smoothing: "Variable Smoothing",
        n_estimators: "Number of Trees (n_estimators)",
        max_features: "Maximum Features per Split",
        min_samples_split: "Minimum Samples Split",
        min_samples_leaf: "Minimum Samples Leaf",
        random_state: "Random Seed (random_state)",
        n_jobs: "Number of Jobs",
        C: "Regularization Parameter (C)",
        kernel: "Kernel Function",
        criterion: "Splitting Criterion",
    };
    const algorithmParams = {
        LogisticRegression: {
            penalty: 12,
            c: 1.0,
            solver: "lbfgs",
            max_iter: 100,
            random_state: 42,
        },
        gradient_boosting: {
            n_estimators: 100,
            learning_rate: 0.1,
            max_depth: 3,
            subSample: 1,
            random_state: 42,
        },
        XGBoost: {
            max_depth: 5,
            gamma: 1,
            alpha: 1,
            eta: 0.3,
        },
        NaiveBayes: {
            var_smoothing: 1e-9,
        },
        RandomForestClassifier: {
            n_estimators: 100,
            max_depth: 5,
            min_samples_split: 2,
            min_samples_leaf: 1,
            random_state: 42,
        },
        TimeSeriesForestClassifier: {
            n_estimators: 50,
            random_state: 42,
            n_jobs: -1
        },
        SupportVectorMachine: {
            C: 1.0,
            kernel: "rbf",
        },
        DecisionTree: {
            criterion: "gini",
            max_depth: 5,
        },
    };
    const [selectedAlgorithm, setSelectedAlgorithm] = react_1.useState(null);
    const [params, setParams] = react_1.useState({});
    const anomalyDetectionParams = {
        structure: {
            num_lstm_layers: 2,
            num_dropout_layers: 2,
            lstm_units: [128, 64],
            dropout_rates: [0.2, 0.1],
            activation: "linear",
            optimizer: "adam",
            loss: "smape_loss"
        },
        parameters: {
            epochs: 100,
            batch_size: 32
        }
    };
    const [anomalyDetectionParamsUpdate, setAnomalyDetectionParamsUpdate] = react_1.useState(anomalyDetectionParams);
    const options = {
        activation: ["linear", "relu", "tanh", "sigmoid"],
        optimizer: ["adam"],
        loss: ["smape_loss", "mean_squared_error", "mean_absolute_error", "huber_loss", "mean_squared_logarithmic_error"],
    };
    react_1.useEffect(() => {
        console.log("anomalyDetectionParamsUpdate", anomalyDetectionParamsUpdate); // remove after finished out
    }, [anomalyDetectionParamsUpdate]);
    react_1.useEffect(() => {
        setModelDetails({
            algorithm: selectedAlgorithm,
            parameters: projectInfo.problemtype === "anomalydetection" ? anomalyDetectionParamsUpdate.parameters : params,
            structure: projectInfo.problemtype === "anomalydetection" ? anomalyDetectionParamsUpdate.structure : {}
        });
    }, [params, setModelDetails, selectedAlgorithm, anomalyDetectionParamsUpdate]);
    const handleAlgoChange = (event) => {
        const selected = event.target.value;
        setSelectedAlgorithm(selected);
        setParams(algorithmParams[selected] || {});
    };
    const handleDropdownChange = (e, field) => {
        setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { structure: Object.assign({}, prev.structure, { [field]: e.target.value }) })));
    };
    const handleParamChange = (event) => {
        const { name, value } = event.target;
        const parsedValue = isNaN(value) ? value : parseFloat(value);
        setParams((prevParams) => (Object.assign({}, prevParams, { [name]: parsedValue })));
    };
    const handleAnomalyParamChange = (event) => {
        const { name, value } = event.target;
        const parsedValue = isNaN(value) ? value : parseFloat(value);
        if (name.includes("_")) {
            let [type, index] = name.split("_");
            let isAssignable = false;
            if (type === "lstm") {
                type = "lstm_units";
                isAssignable = true;
            }
            else if (type === "dropout") {
                type = "dropout_rates";
                isAssignable = true;
            }
            console.log(type, index);
            if (isAssignable) {
                setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { structure: Object.assign({}, prev.structure, { [type]: prev.structure[type].map((v, i) => i === parseInt(index - 1) ? parsedValue : v) }) })));
            }
        }
        switch (name) {
            case "num_lstm_layers":
                setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { structure: Object.assign({}, prev.structure, { num_lstm_layers: parsedValue }) })));
                if (parsedValue > anomalyDetectionParamsUpdate.structure.lstm_units.length) {
                    const newArray = [...anomalyDetectionParamsUpdate.structure.lstm_units];
                    while (newArray.length < parsedValue) {
                        newArray.push(NaN);
                    }
                    setAnomalyDetectionParamsUpdate(prevState => (Object.assign({}, prevState, { structure: Object.assign({}, prevState.structure, { lstm_units: newArray }) })));
                }
                else if (parsedValue < anomalyDetectionParamsUpdate.structure.lstm_units.length) {
                    const newArray = anomalyDetectionParamsUpdate.structure.lstm_units.slice(0, parsedValue);
                    setAnomalyDetectionParamsUpdate(prevState => (Object.assign({}, prevState, { structure: Object.assign({}, prevState.structure, { lstm_units: newArray }) })));
                }
                break;
            case "num_dropout_layers":
                setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { structure: Object.assign({}, prev.structure, { num_dropout_layers: parsedValue }) })));
                if (parsedValue > anomalyDetectionParamsUpdate.structure.dropout_rates.length) {
                    const newArray = [...anomalyDetectionParamsUpdate.structure.dropout_rates];
                    while (newArray.length < parsedValue) {
                        newArray.push(NaN);
                    }
                    setAnomalyDetectionParamsUpdate(prevState => (Object.assign({}, prevState, { structure: Object.assign({}, prevState.structure, { dropout_rates: newArray }) })));
                }
                else if (parsedValue < anomalyDetectionParamsUpdate.structure.dropout_rates.length) {
                    const newArray = anomalyDetectionParamsUpdate.structure.dropout_rates.slice(0, parsedValue);
                    setAnomalyDetectionParamsUpdate(prevState => (Object.assign({}, prevState, { structure: Object.assign({}, prevState.structure, { dropout_rates: newArray }) })));
                }
                break;
            case "epochs":
                setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { parameters: Object.assign({}, prev.parameters, { epochs: parsedValue }) })));
                break;
            case "batch_size":
                setAnomalyDetectionParamsUpdate((prev) => (Object.assign({}, prev, { parameters: Object.assign({}, prev.parameters, { batch_size: parsedValue }) })));
                break;
            default:
                break;
        }
    };
    const renderFormQuestions = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, style: { fontWeight: 900, fontSize: 14, marginBottom: "2px" } }, "Hyper Parameter Tuning List"),
        Object.keys(params).map((param) => (react_1.default.createElement(core_1.Box, { key: param, style: { marginBottom: 2 } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, actualNames[param]),
            react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, name: param, value: params[param], onChange: handleParamChange, type: typeof params[param] === "number" ? "number" : "text" }))))));
    const renderAnomalyDetectionQuestions = () => {
        const numLstmLayers = anomalyDetectionParamsUpdate.structure.num_lstm_layers || 0;
        const numDropoutLayers = anomalyDetectionParamsUpdate.structure.num_dropout_layers || 0;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Grid, { container: true, style: { marginBottom: 2 } },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 16, fontWeight: 900 } }, "Structure"))),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, style: { marginBottom: 4 } },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Number of LSTM layers"),
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, name: "num_lstm_layers", value: numLstmLayers || "", onChange: handleAnomalyParamChange, type: "number" })),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Number of Dropout layers"),
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, name: "num_dropout_layers", value: numDropoutLayers || "", onChange: handleAnomalyParamChange, type: "number" }))),
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "LSTM Layers Details")),
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, style: { marginBottom: 4 } }, Array.from({ length: numLstmLayers }).map((_, index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 / numLstmLayers, key: `lstm-layer-${index}` },
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, label: `LSTM Layer ${index + 1}`, name: `lstm_${index + 1}`, value: anomalyDetectionParamsUpdate.structure.lstm_units[index] || "", onChange: handleAnomalyParamChange })))))),
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "LSTM Layers Details")),
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, style: { marginBottom: 4 } }, Array.from({ length: numDropoutLayers }).map((_, index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 / numDropoutLayers, key: `dropout-layer-${index}` },
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, label: `Dropout Layer ${index + 1}`, name: `dropout_${index + 1}`, value: anomalyDetectionParamsUpdate.structure.dropout_rates[index] || "", onChange: handleAnomalyParamChange })))))),
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Activation"),
                    react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: anomalyDetectionParamsUpdate.structure.activation, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "activation") }, options.activation.map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))))),
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Optimizer"),
                    react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: anomalyDetectionParamsUpdate.structure.optimizer, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "optimizer") }, options.optimizer.map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))))),
            react_1.default.createElement(core_1.Grid, null,
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Loss Function"),
                    react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: anomalyDetectionParamsUpdate.structure.loss, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "loss") }, options.loss.map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))))),
            react_1.default.createElement(core_1.Grid, { container: true, style: { marginBottom: 2 } },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 16, fontWeight: 900 } }, "Parameters"))),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, style: { marginBottom: 4 } },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Number of Epochs"),
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, name: "epochs", value: anomalyDetectionParamsUpdate.parameters.epochs || "", onChange: handleAnomalyParamChange, type: "number" })),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 14 } }, "Batch Size"),
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", fullWidth: true, margin: "dense", style: { height: 40 }, name: "batch_size", value: anomalyDetectionParamsUpdate.parameters.batch_size || "", onChange: handleAnomalyParamChange, type: "number" })))));
    };
    const cases = [
        { value: "LogisticRegression", label: "Logistic Regression", problemType: "RootCauseAnalysis" },
        { value: "gradient_boosting", label: "Gradient Boosting", problemType: "RootCauseAnalysis" },
        { value: "XGBoost", label: "XGBoost", problemType: "regression" },
        // { value: "NaiveBayes", label: "Naive Bayes", problemType: "none" },
        { value: "RandomForestClassifier", label: "Random Forest Classifier", problemType: "RootCauseAnalysis" },
        { value: "TimeSeriesForestClassifier", label: "Time Series Forest Classifier", problemType: "eventclassification" },
        // { value: "SupportVectorMachine", label: "Support Vector Machine SVM", problemType: "none" },
        // { value: "DecisionTree", label: "Decision Tree", problemType: "none" },
        { value: "LSTM", label: "Long Short-Term Memory (LSTM)", problemType: "anomalydetection" },
    ];
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: selectedAlgorithm ? 2 : 4, lg: selectedAlgorithm ? 2 : 4 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: selectedAlgorithm ? 8 : 4, lg: selectedAlgorithm ? 8 : 4, style: { backgroundColor: "white", padding: "30px" } },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                isVisualizationTable &&
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 }, visualizationData && Object.keys(visualizationData).length > 0 ? (Object.values(visualizationData).map((imgUrl, index) => (react_1.default.createElement("img", { key: index, src: imgUrl, alt: `Visualization ${index + 1}`, style: { width: "100%", display: "block", marginBottom: "20px" } })))) : (react_1.default.createElement(core_1.Typography, { variant: "body1" }, "No Images to Show..."))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: selectedAlgorithm ? 5 : 12, lg: selectedAlgorithm ? 5 : 12, style: { paddingTop: "0px" } }, !isVisualizationTable &&
                    react_1.default.createElement(core_1.Box, { border: 1, borderColor: "grey.400", padding: "40px 20px", borderRadius: "10px", style: { padding: "40px", height: "508px" } },
                        react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, style: { marginBottom: "23px", fontWeight: 600, fontSize: 24 } }, "Available Algorithm"),
                        errorMessages && errorMessages.modelDetailsError && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", style: { marginLeft: "1px", fontSize: 11 } }, errorMessages.modelDetailsError)),
                        react_1.default.createElement(core_1.RadioGroup, { value: selectedAlgorithm, onChange: handleAlgoChange }, cases.map((c) => (react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center", marginBottom: "10px", width: "100%", key: c.value },
                            react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center", paddingLeft: 3, border: 1, borderColor: "grey.400", height: 50, width: "100%", borderRadius: "10px", marginRight: 1, color: "#324054" },
                                react_1.default.createElement(core_1.FormControlLabel, { value: c.value, control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: c.label, disabled: c.problemType !== projectInfo.problemtype })))))))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 7, lg: 7, style: { paddingTop: "0" } }, !isVisualizationTable &&
                    selectedAlgorithm ? (react_1.default.createElement(core_1.Box, { border: 1, borderColor: "grey.400", padding: "40px 20px", borderRadius: "10px", height: "508px" }, projectInfo.problemtype === "anomalydetection" ? renderAnomalyDetectionQuestions() : renderFormQuestions())) : (react_1.default.createElement(core_1.Box, { height: "100%" }))))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: selectedAlgorithm ? 2 : 4, lg: selectedAlgorithm ? 2 : 4 })));
}
exports.ModelTuningStep1 = ModelTuningStep1;
//# sourceMappingURL=model-tuning-step1.js.map